import React from 'react';
import PropTypes from 'prop-types';
import { Column, Direction, Grid, Margin } from '@scotia/canvas-react';
import { Alignment } from '../Alignment';

import style from './VerticalLayout.scss';

export const VerticalLayout = props => (
  <Grid style={{ margin: '0px' }}>
    <Direction>
      <Column
        md={2}
        xs={6}
        mdOffset={5}
        xsOffset={3}
        style={{ padding: '0px' }}
      >
        <div className={style['svg-notification-container']}>{props.icon}</div>
      </Column>
      <Column md={6} xs={12} mdOffset={3}>
        <Margin side="top" xs={12} md={12}>
          <Alignment xs="center" md="center">
            {props.header}
          </Alignment>
        </Margin>
      </Column>
    </Direction>
    <Margin side="top" xs={24} md={24}>
      {props.body}
    </Margin>
    <Alignment xs="center" md="center">
      {props.footer}
    </Alignment>
  </Grid>
);

VerticalLayout.propTypes = {
  icon: PropTypes.node,
  header: PropTypes.node.isRequired,
  body: PropTypes.node.isRequired,
  footer: PropTypes.node.isRequired
};
